import { createContext, useContext, useEffect, useState } from "react";
import { useServer } from "./ServerContext";
import { businessEndpoints } from "../env";

const BusinessContext = createContext(undefined);

export const BusinessProvider = ({children}) => {
    //HOOKS
    const { getRequest } = useServer();

    //STATES
    const [businessLocation, setBusinessLocation] = useState(null);
    const [businessInfo, setBusinessInfo] = useState(null);

    //FUNCTIONS
    const loadBusinessLocation = () => {
        getRequest(businessEndpoints.get_location, {}, (res) => {
            if (res[0])
            {
                setBusinessLocation(res[1].location);
            }
        });
    }

    const loadBusinessInfo = () => {
        getRequest(businessEndpoints.get_info, {}, (res) => {
            setBusinessInfo(res[1].business_info);
        });
    }

    //EFFECTS
    useEffect(() => {
        loadBusinessLocation();
        loadBusinessInfo();
    }, []);

    const value = {
        businessLocation,
        loadBusinessLocation,
        businessInfo,
    }

    return (
        <BusinessContext.Provider value={value}>
            {children}
        </BusinessContext.Provider>
    );
}

export const useBusiness = () => useContext(BusinessContext);
